import { IppicaScommesseEsitoRenderer } from '../ippicaScommesseEsito/ippicaScommesseEsitoRenderer';
import { ScommesseTipoBoxUiContainer } from '../ippicaScommesseEsitoTipoBox/IppicaScommesseEsitoTipoBox';
import styles from './IppicaScommesseTableRow.module.scss';
import { IppicaScommesseTableRowTestaATesta } from './IppicaScommesseTableRowTestaATesta';
import { IppicaScommesseTableRowUiContainer } from './ippicaScommesseTableRowUiContainer';
export type IppicaScommesseTableRowProps = {
  indexCavallo: number;
  keyCavallo: string;
  providerID?: number;
};

export const IppicaScommesseTableRow = ({ indexCavallo, keyCavallo }: IppicaScommesseTableRowProps) => {
  return (
    <IppicaScommesseTableRowUiContainer keyCavallo={keyCavallo}>
      <IppicaScommesseEsitoRenderer keyCavallo={keyCavallo} indexCavallo={indexCavallo} />
    </IppicaScommesseTableRowUiContainer>
  );
};
